import {
  DirectionEnum,
  IDropdownItem,
  IRouteSchedule,
  trimCsvForGrid,
} from "@ryde/shared";

import { IExpandedRouteSchedule } from "./course-schedule-cell.models";

export const isPickupDirection = (direction: string): boolean =>
  direction === DirectionEnum.PickUp;

export const resolveScheduleDirectionLabel = (
  direction: string,
): DirectionEnum =>
  isPickupDirection(direction) ? DirectionEnum.PickUp : DirectionEnum.DropOff;

export const expandRouteSchedules = ({
  schedules,
  dropdownItems,
}: {
  schedules: IRouteSchedule[];
  dropdownItems: IDropdownItem[];
}): IExpandedRouteSchedule[] =>
  schedules.map(schedule => {
    const dayTypeIdsSet = schedule.dayTypeIds
      ? new Set(schedule.dayTypeIds)
      : null;
    const names = dropdownItems
      .filter(item => dayTypeIdsSet?.has(+item.value))
      .map(item => item.label);

    return {
      ...schedule,
      dayTypeNames: trimCsvForGrid(names),
    };
  });
